var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.511719,
    y: 0.534668,
    width: 17.6744,
    height: 17.907,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1491_6469",
    transform: "translate(0 0.00649348) scale(0.01 0.00987013)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1491_6469",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEMklEQVR4nO3dTWhcVRjG8f/b1gp+BeoniIao4MaFHwuLiGAUtOJXceVSxJ26sG7cKLiVLkTcKIgLA2pBu9CF4DLLWEGN2oXEKlaMlTZWCUnaPi7uFDTmnrk5986Zd2be3669OXOeO0/u5NybyR0IIYQQQgjds2EHyCXpEuAG4CrgYuAEsGhmp4YarKWRKUTSNcCjwCxwF3BdzZeuAj8BXwILwGdm9k2RkONOkkl6SNInkjaUb0nSK5KuHfY+jSxJD0g60qKEraxLeltS3dEVNpN0taRDHRex2aqklyRdMOz9dU3SvZKOD7iMf1uQNDPs/XZJ0tOSzhQs47w/JN037P0/z8UqS9IB4DWa5zkFzAOLwDFgpff/U8A0cAtwd+/fTawBT5rZx00zj63ekXGuwXfyuqT3JM1K2tngcXdKul/SnJqt0DYk7Suxz26p+pnR5GVqTtJ0i3lmJL3fYJ7Tkm7tch9HhqrV1K99nqDlLr9rJT0s6fc+cx5VdRVgsqj/0vZbSdcPYN5pSd/1mfutrud1TdVJX78yrhjg/Ff2KeWspDsHNb8rqi6HpM7Al1XgTLp3pJxI5JgfdAYXVF2bSim20lH1MyXlnlJZhkbSp4knYG4IeT5I5PmodJ6iVK2s6s4J1tViadsi00wi05qky0vm2VFyMuAxYFfNtg/N7FjJMABmtgQcqtm8G3ikYJzihcwmtr1TLMX/vZvYlso82iT9XPPScFINLocMMNcuSSs12ZZKZil2hKg6+637jd28mZ0tlWUzMztDdbFyK9OSLiqVpeRL1k3UX81dLJijTl0Go8peRMlC9iS2/VgsRb1UhmIrrZKFXJrYdrpYinp/JralsneqZCG7E9vWi6Wot5bYdmGpEKWXvaGPKMSZKMSZKMSZKMSZugt92ybpRuBmqneib2VvYvheSV1FyZWb72/gqJn90EWI1u/LkrQfeJXqvVCT7GvgZTM73OZBWhUi6SDwQpvHGEMHzezF3MHZhUh6Hng9d/yYe9bM3swZmFWIpD3AEnBZzvgJsALMmNnJ7Q7MXWU9QZSRMgXszxmYW8jtmeMmyR05g3ILSV1KD5WsN/rlFuLizxicy3qO4kzdmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmSjEmdxCNjpNMZ6ybuyZW8jxzHGT5JecQbmFfJ45bpJkPUe5dwPaAXwBTOZHzPX3FXCbmZ3b7sCsI6Q30TNUn10e/msVeCqnDGixyjKzBWAfsJz7GGPoN+BBMzuS+wBd3HNxCngOeJzqJpiT9qGMfwHfA4eBN8wsdQ/5EEIIIYQQQgghjJR/AFJzf+DXgz4EAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.43c464d5080c617d0481d598480e7123.svg";
export { ForwardRef as ReactComponent };